
import { mapState } from "vuex";
import {
  configState,
  configGetters,
  configMutations,
  dashboardGetters,
  organizationsGetters,
  dashboardActions,
} from "~/store/helpers";
import draggable from "vuedraggable";
export default {
  props: {
    modalTitle: String,
    modalKey: String,
    okTitle: String,
    cancelTitle: String,
  },
  data() {
    return {
      input: "",
      boardsList: [],
      boardNameEmpty: false,
      oldBoardList: [],
      boardNameExists: false,
      selectToBeDeleted: null,
      selectedBoard: null,
      boardToBeEdited: null,
      editing: false,
      movedBoards: [],
      deletingArr: [],
    };
  },
  mounted() {
    this.boardsList = JSON.parse(JSON.stringify(this.tabs)).map((e, i) => ({
      ...e,
      order: i,
    }));
    this.oldBoardList = JSON.parse(JSON.stringify(this.boardsList));
  },
  computed: {
    ...dashboardGetters,
    ...configGetters,
    ...organizationsGetters,
    ...mapState({
      organization(state) {
        return this.getOrganization();
      },
    }),
    tabs() {
      return this.getOrgBoards().map((e) => ({
        ...e,
        value: e.name,
        disabled: true,
      }));
    },
  },
  // if(board.id && board.value != board.name) {
  //           this.$emit("updateBoardOrder", {
  //           id: board.id,
  //           name: board.value,
  //           order: board.order,
  //           disabled: true,
  //           });
  //         }
  watch: {
    tabs(val) {
      this.boardsList = val;
    },
  },
  methods: {
    ...configMutations,
    ...dashboardActions,
    showDeleteModal(element) {
      this.selectToBeDeleted = element;
      this.$bvModal.show(`modal-scoped`);
    },
    deleteBoards(event) {
      event.preventDefault();
      if (this.selectToBeDeleted.id) {
        let findDeleteBoardIndex = this.boardsList.findIndex((board) => {
          return board.id === this.selectToBeDeleted.id;
        });
        this.deletingArr.push(this.selectToBeDeleted.id);
        this.boardsList.splice(findDeleteBoardIndex, 1);
      }
      if (!this.selectToBeDeleted.id) {
        let removeBoard = this.boardsList.findIndex((board) => {
          return board.value === this.selectToBeDeleted.value;
        });
        this.boardsList.splice(removeBoard, 1);
      }
      this.$nextTick(() => {
        this.$bvModal.hide("modal-scoped");
      });
      //this.$emit("deleteCurrentBoard", this.selectToBeDeleted);
      this.selectToBeDeleted = null;
    },
    addField() {
      this.boardNameEmpty = this.boardsList.find((board) => !board.value);
      const allBoardValues = this.boardsList.map((board) => {
        return board.value;
      });
      const isDuplicate = allBoardValues.some((board, idx) => {
        return allBoardValues.indexOf(board) !== idx;
      });
      this.boardNameExists = isDuplicate;
      if (this.boardNameEmpty || this.boardNameExists) {
        // this.myArray = this.myArray.filter(e => !e.value)
        return;
      }
      let newBoardField = this.boardsList.find((e) => !e.id && !e.disabled);
      if (newBoardField) {
        newBoardField.disabled = !newBoardField.disabled;
      }
      this.boardsList.push({ value: null, disabled: false, newBoard: true });
    },
    editField(element) {
      this.editing = true;
      element.updating = true;
      element.disabled = false;
    },
    // handleUpdate(newName) {
    //   let newBoardName = newName;
    //   let boardId = this.selectedBoard;
    //   this.$emit("updateBoardOrder", {
    //     id: boardId,
    //     name: newBoardName,
    //     order: this.boardToBeEdited.order,
    //     disabled: !this.boardToBeEdited.disabled,
    //   });
    //   this.selectedBoard = null;
    // },
    changed(event) {
      if (event && event.moved && !event.moved.element.content) {
        this.boardsList.splice(
          event.moved.index,
          0,
          this.boardsList.splice(event.moved.index, 1)[0]
        );

        this.movedBoards.push(event.moved);
      }
    },
    updateBoard(element) {
      if (!/^[^/]*$/.test(element.value)) {
        return;
      }
      this.editing = false;
      element.updating = false;
      element.disabled = true;
    },
    async handleAction() {
      let board_ids = this.deletingArr;
      if (board_ids.length) {
        await this.$axios.delete(
          `${localStorage.getItem("organizationId")}/boards`,
          {
            data: {
              board_ids,
            },
          }
        );
      }
      this.$emit(
        "addBoard",
        this.boardsList
          .filter((e) => e.newBoard)
          .map((e) => ({ name: e.value }))
      );
      this.boardsList.forEach((element) => {
        if (element.id) {
          this.$emit("updateBoardOrder", {
            id: element.id,
            name: element.value,
            order: element.order,
            disabled: true,
          });
        }
      });
      this.$nextTick(() => {
        this.movedBoards.forEach((element) => {
          if (element.element.id) {
            this.$emit("updateBoardOrder", {
              id: element.element.id,
              name: element.element.value,
              order: element.newIndex,
              disabled: true,
            });
          }
        });
        this.$emit("getBoardsForOrg");
      });
    },
    handleCancel(element) {
      element.updating = !element.updating;
      element.disabled = true;
      element.value = element.name;
      this.editing = false;
    },
    AddBoard(element) {
      if (!/^[^/]*$/.test(element.value)) {
        return;
      }

      // if(element.value.check)
      this.boardNameExists = this.boardsList.some(
        (board) => element.value == board.name
      );
      if (this.boardNameExists) {
        return;
      } else if (!element.value) {
        this.boardNameEmpty = true;
        return;
      } else {
        element.disabled = true;
        element.name = element.value;
        this.boardNameExists = false;
        this.boardNameEmpty = false;
        this.addField();
      }
    },
    handleClose() {
      this.boardsList = this.boardsList.filter((board) => {
        if (!board.id) {
          return board.id != null && board.value != null;
        }
        return (board.disabled = true);
      });
      this.boardsList.forEach((board) => {
        board.value = board.name;
        delete board.updating;
      });
      if (this.deletingArr.length) {
        this.deletingArr.forEach((id) => {
          this.$emit("deleteCurrentBoard", id);
        });
        this.$nextTick(() => {
          this.$emit("getBoardsForOrg");
        });
      }
      this.editing = false;
      this.boardNameExists = false;
      this.movedBoards = [];
      this.$bvModal.hide("item1");
    },
    handleSlashes(event) {
      if (event.key === "/") {
        event.preventDefault();
      }
    },
    showCancelModalHandler() {
      this.boardsList = this.boardsList.filter((board) => {
        return board.id || board.value;
      });
      let checkIfThereAreUpdatedBoards = this.boardsList.filter((board) => {
        return board.value != board.name;
      });
      if (
        this.boardsList.length > this.oldBoardList.length ||
        checkIfThereAreUpdatedBoards.length
      ) {
        this.$bvModal.show("cancelModal");
      } else {
        this.$bvModal.hide("item1");
        if (this.deletingArr.length) {
          this.deletingArr.forEach((id) => {
            this.$emit("deleteCurrentBoard", id);
          });
          this.$nextTick(() => {
            this.$emit("getBoardsForOrg");
          });
        }
        this.handleClose();
      }
    },
  },
  components: {
    draggable,
  },
};
